module.exports = __webpack_public_path__ + "static/online-c416090d2b57f6a5a564b78f710c3668.png";